import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ResendOverdraftWelcomeEmailPreview } from '@portal-workspace/grow-shared-library';
import { MessageBoxComponent } from '../message-box/message-box.component';

export interface ResendOverdraftWelcomeEmailDialogResult {
  send: boolean;
}

@Component({
  templateUrl: './resend-overdraft-welcome-email.dialog.html',
  styleUrls: ['./resend-overdraft-welcome-email.dialog.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MessageBoxComponent],
})
export class ResendOverdraftWelcomeEmailDialogComponent {
  previewHtml: SafeHtml;

  constructor(
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: ResendOverdraftWelcomeEmailPreview,
    private matRef: MatDialogRef<ResendOverdraftWelcomeEmailDialogComponent, ResendOverdraftWelcomeEmailDialogResult>,
  ) {
    this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(data.html);
  }

  cancel() {
    this.matRef.close();
  }

  send() {
    this.matRef.close({ send: true });
  }
}
